import camelCase from 'lodash/camelCase'
import { useCmsFetch } from '@/composables/craft-fetch'
import { useCacheStore } from '~/store/cache'

const fallback = Object.freeze({
  articleOverview: Object.freeze({ title: undefined, url: undefined }),
  department: undefined,
  landing: Object.freeze({ title: undefined, url: undefined }),
  shelterDetail: Object.freeze({ title: undefined, url: undefined }),
  site: Object.freeze({ handle: undefined, language: undefined, name: undefined }),
})

export const useGlobalStore = defineStore('global', () => {
  const cacheStore = useCacheStore()
  const cmsFetch = useCmsFetch()

  const state = {
    articleOverview: ref({ title: undefined, url: undefined }),
    department: ref(undefined),
    landing: ref({ title: undefined, url: undefined }),
    shelterDetail: ref({ title: undefined, url: undefined }),
    site: ref({ handle: undefined, language: undefined, name: undefined }),
  }

  function set({ articleOverview, department, landing, shelterDetail, site }) {
    state.articleOverview.value = articleOverview
    state.department.value = department
    state.landing.value = landing
    state.shelterDetail.value = shelterDetail
    state.site.value = site
  }

  async function fetchSeo() {
    const key = `global;seo`
    const ttl = 3600

    const fetcher = async () => {
      return await cmsFetch(`/api/global/seo/default.json`)
    }

    return await cacheStore.fetch({ key, ttl, fetcher })
  }

  async function fetchJobOfferCtas() {
    const key = `global;jobOfferCtas`
    const ttl = 3600

    const fetcher = async () => {
      return await cmsFetch(`/api/global/jobOfferCtas/default.json`)
    }

    return await cacheStore.fetch({ key, ttl, fetcher })
  }

  async function fetchSiteGlobals({ site, slug, push }) {
    const site_ = site || camelCase(slug)
    const key = `global;site:${site_}`
    const ttl = 3600

    const fetcher = async () => {
      return await cmsFetch(`/api/global/site/${site_}.json`)
    }

    const data = await cacheStore.fetch({ key, ttl, fetcher, fallback })
    if (push) {
      set(data)
    }
    return data
  }

  return { ...state, set, fetchSeo, fetchJobOfferCtas, fetch: fetchSiteGlobals }
})
